<script></script>

<div class="main">
    <div class="title">
        AMBASSADORS
    </div>
    <div class="img-wrapper">
        <img width="100%" height="100%" src="images/web3_pages/ambassadors.png" alt="ambassadors">
    </div>
    <div class="detail">
        2nd cohort of <span>OPUS Student Ambassador program </span>
        with the aim to make our ecosystem recognizable from an early age.
    </div>
</div>

<style>
    .main{
        width: 33.854vw;
        height: 47.917vw;
        background-color: #ffffff;
        box-shadow: -0.208vw 0.208vw 0.417vw rgba(0, 0, 0, 0.5);
        border-radius: 2.083vw;
        position: relative;
        font-family: 'Montserrat';
        font-style: normal;
        color: #FF007F;
    }
    .title{
        font-weight: 900;
        font-size: 2.604vw;
        line-height: 74.5%;
        text-align: center;
        position: absolute;
        top: 3.365vw;
        width: 100%;
    }
    .img-wrapper{
        position: absolute;
        top: 9.042vw;
        left: 5.729vw;
        width: 22.396vw;
        height: 22.396vw;
    }
    .img-wrapper img{
        pointer-events: none;
    }
    .detail{
        width: 18.503vw;
        position: absolute;
        top: 34.51vw;
        left: 0;
        right: 0;
        margin: auto;
        font-weight: 500;
        font-size: 1.563vw;
        line-height: 100%;
    }
    .detail span{
        font-weight: 700;
    }
</style>